import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

const ModuleVersionTableNameCell = <T extends { id: string }>({
  item,
  ...cellProps
}: TableSimpleCellProps<T>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{item.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default ModuleVersionTableNameCell;
